export function Container(props) {
	return (
		<div className="pd-article__full">
			<div className="pd-article__wrapper">
				<div className="pd-article__max-width">{props.children}</div>
			</div>
		</div>
	);
}

export default Container;
